import { Component, Input, OnInit } from '@angular/core';
import { ProductsWithPriceAndNoteLabels, ProductWithPriceAndAdditionalInfo } from '../../models/types';
import { getPathwayProgramFeesLabels } from '../../utils/table-utils';
import { Company, CompanyEnum } from '../../models/company.model';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { PriceAndNoteTableComponent } from '../price-and-note-table/price-and-note-table.component';
import { PriceListPathwayProgramFee } from '../../models/pricelist-pathway-program-fee .model';
import { Currency } from '../../models/currency.model';

@Component({
  standalone: true,
  imports: [TableHeaderComponent, PriceAndNoteTableComponent],
  selector: 'lx-price-lists-portal-pathway-program-fee-table',
  templateUrl: './pathway-program-fee-table.component.html',
  styleUrls: ['./pathway-program-fee-table.component.scss'],
})
export class PathwayProgramFeeTableComponent implements OnInit {
  @Input() pathwayProgramFees: PriceListPathwayProgramFee[] | undefined;
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.KIL;

  dataSource: ProductWithPriceAndAdditionalInfo[] = [];
  columnLabels: ProductsWithPriceAndNoteLabels | undefined;

  ngOnInit(): void {
    this.columnLabels = getPathwayProgramFeesLabels();

    this.dataSource = this.pathwayProgramFees?.map(({ program, fee, note }) => ({
      name: program,
      price: fee,
      additionalInfo: note,
    }));
  }
}
